import { createAction, props } from '@ngrx/store';

// Representación del usuario según la tabla `users`
// CREATE TABLE users (
//   id_user INT PK AI,
//   nombre VARCHAR(100),
//   usuario VARCHAR(45),
//   celular VARCHAR(45),
//   password VARCHAR(255) NOT NULL,
//   id_rol INT NOT NULL DEFAULT 2,
//   created TIMESTAMP DEFAULT CURRENT_TIMESTAMP
// )

export interface AppUser {
  id_user: number | null;
  nombre: string | null;
  usuario: string | null;
  correo: string | null;
  celular: string | null;
  password: string | null;
  id_rol: number | null;
  img: string | null;
  created: string | null;
}

// Acción compuesta para setear todo el usuario de un jalón
export const setUser = createAction(
  '[Auth] Set User',
  props<{ user: AppUser }>()
);

// Limpia el usuario (logout)
export const clearUser = createAction('[Auth] Clear User');

// Acciones atómicas (por si las necesitas individualmente)
export const setUserId = createAction(
  '[Auth] Set User ID',
  props<{ id_user: number | null }>()
);

export const setUserNombre = createAction(
  '[Auth] Set User Nombre',
  props<{ nombre: string | null }>()
);

export const setUserUsuario = createAction(
  '[Auth] Set User Usuario',
  props<{ usuario: string | null }>()
);

export const setUserCelular = createAction(
  '[Auth] Set User Celular',
  props<{ celular: string | null }>()
);

